import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";

import MomentsUser from "../../components/MomentsUser";
// import MomentsQueues from "../../components/MomentsQueues";

import MainHeader from "../../components/MainHeader";
import { Grid, Paper } from "@material-ui/core";
import Title from "../../components/Title";
import ForbiddenPage from "../../components/ForbiddenPage";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: "5px",
    maxWidth: "100%",
    background: theme.palette.background.default,
    minHeight: "100vh",
  },
  mainPaper: {
    display: "flex",
    padding: theme.spacing(2),
    overflowY: "auto",
    ...theme.scrollbarStyles,
    justifyContent: "center", // Centraliza horizontalmente
    background: theme.palette.background.default,
    borderRadius: 20,
    minHeight: "90vh",
    boxShadow: "0 4px 24px 0 rgba(0,0,0,0.07)",
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    height: 100,
  },
  chatPapper: {
    display: "flex",
    height: "100%",
  },
  contactsHeader: {
    display: "flex",
    flexWrap: "wrap",
    padding: "0px 6px 6px 6px",
  },
}));

const ChatMoments = () => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  return user.profile === "user" && user.allowRealTime === "disabled" ? (
    <ForbiddenPage />
  ) : (
    <MainHeader>
      <Grid
        style={{ width: "100%", height: "100vh" }} // Força altura total do Grid pai
        container
        justifyContent="center"
        alignItems="center"
      >
        <Grid xs={12} sm={8} xl={4} item style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', marginBottom: 25, marginTop: 25 }}>
          <Title style={{
            fontWeight: 600,
            fontSize: 28,
            color: '#222',
            textAlign: 'center',
            letterSpacing: 0.2,
            width: '100%',
            margin: 0,
            padding: 0,
            lineHeight: 1.2,
          }}>
            Monitoramento em tempo real
          </Title>
        </Grid>
        <Grid style={{ width: "100%", height: "100vh" }} item>
          <Paper
            className={classes.mainPaper}
            style={{ maxWidth: "100%" }}
          >
            <MomentsUser />
          </Paper>
        </Grid>
      </Grid>
    </MainHeader>
  );
};

export default ChatMoments;
